<template>
  <section v-if="teams.length" :class="$style.eliminated" aria-live="polite">
    <h4 :class="$style.title">{{ t('title') }}</h4>
    <ul :class="$style.list">
      <li v-for="team in teams" :key="team.id" :class="$style.item">
        <team-icon :team="team" size="s" outline="danger" />
      </li>
    </ul>
  </section>
</template>

<i18n lang="yaml">
ru:
  title: Выбывшие команды
</i18n>

<script lang="ts" setup>
import { computed } from 'vue'
import TeamIcon from '../../common/TeamIcon.vue'
import type { PickemTeam } from '../../../types'

defineOptions({ name: 'PickemSwissEliminatedTeams' })

const props = defineProps<{
  teamIds: number[]
  teamsById: Record<number, PickemTeam>
}>()

const { t } = useI18n()

const teams = computed(() =>
  props.teamIds
    .map(id => props.teamsById[id])
    .filter((value): value is PickemTeam => Boolean(value))
)
</script>

<style lang="scss" module>
.eliminated {
  padding: 2em;
  border-radius: 1.2em;
  background-color: color-get(--root-rgb-bg-card);
  display: flex;
  flex-direction: column;
  gap: 0.8em;
}

.title {
  margin: 0;
  @include typo-get(subhead-m);
  color: color-get(--root-rgb-text-2);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.6em;
}

.item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4em;
  padding: 1.4em;
  width: 8em;
  height: 8em;
  border-radius: 999px;
  background-color: color-get(--root-rgb-bg-default);
}
</style>
